<div class="modal">
	<%= content %>
</div>
